<tt-page *ngIf="page">
    <tt-card class="col-xs-12 sp-0">
        <tt-input ttLabel="resource_name" [ttModel]="page.resource_name" ttReadonly></tt-input>
        <tt-button *ngIf="page.show_button_crew === '1'" ttText="sroperationresource_crews" [ttBadge]="page.nbr_of_crews" ttIcon="fas fa-chevron-right" ttIconPullRight ttTextAlign="left" ttGoto="srcrews" [ttGotoParms]="{ argtype: 'resource_id', argvalue: page.resource_id }"></tt-button>
        <tt-button *ngIf="page.show_button_delete === '1'" ttText="sroperationresource_delete" ttIcon="fas fa-trash-alt" ttType="danger" [ttLoading]="deleting" (ttClick)="deleteValues()"></tt-button>
    </tt-card>
</tt-page>
